import { useState } from "react";

export default function ContextAppState() {
    const [dataListTool, setDataListTool] = useState({});
    const [listToolRedirect, setListToolRedirect] = useState([]);
    const [userPermission, setUserPermission] = useState({});
    const [timeOutLwt, setTimeoutLwt] = useState(true);
    const [timeOutEnableContact, setTimeoutEnableContact] = useState(true);
    const [timeOutEnableSmoke, setTimeoutEnableSmoke] = useState(true);
    const [timeOutEnableLockRemote, setTimeoutEnableLockRemote] = useState(true);
    const [timeOutSwitchOutput, setTimeoutSwitchOutput] = useState(true);
    const [timeOutOnClose, setTimeoutOnClose] = useState(true);
    const [nameDeviceDetail, setNameDeviceDetail] = useState('');
    const [timeoutLicense, setTimeoutLicense] = useState(true);
    const [timeoutAllState, setTimeoutAllState] = useState(true);
    const [timeoutInstall, setTimeoutInstall] = useState(true);
    const [historyLogs, setHistoryLogs] = useState([]);
    const [licenseListAll, setLicenseListAll] = useState([]);
    const [loadingHistoryLogs, setLoadingHistoryLog] = useState(false);
    //deviceoff
    const [deviceOff, setDeviceOff] = useState([]);
    const [loadingDeviceOff, setLoadingDeviceOff] = useState(true);
    //history device

    const [deviceOffline, setDeviceOffline] = useState([]);
    const [loadingOffline, setLoadingOffline] = useState(true);

    const [deviceStatus, setDeviceStatus] = useState([]);
    const [loadingDeiceStatus, setLoadingDeviceStatus] = useState(true);

    const [enableContact, setEnableContact] = useState([]);
    const [loadingEnableContact, setLoadingEnableContact] = useState(true);

    const [enableSmoke, setEnableSmoke] = useState([]);
    const [loadingEnableSmoke, setLoadingEnableSmoke] = useState(true);

    const [enableLockRemote, setEnableLockRemote] = useState([]);
    const [loadingEnableLockRemote, setLoadingEnableLockRemote] = useState(true);

    const [historyOffline, setHistoryOffline] = useState([]);
    const [loadingHistoryOffline, setLoadingHistoryOffline] = useState(true);
    const [loadingLicenseList, setLoadingLicenseList] = useState(true);

    //
    const [logActionList, setLogActionList] = useState([]);
    const [loadingLogActionList, setLoadingLogActionList] = useState(true);
    //box data
    const [dataBox, setDataBox] = useState({});
    const [dataBoxCustomer, setDataBoxCustomer] = useState({});
    //logs stats
    const [dataLicenseStats, setDataLicenseStats] = useState([]);
    const [dataReasonStats, setDataReasonStats] = useState([]);
    const [totalLogAction, setTotalLogAction] = useState(0);
    //
    return {
        deviceOffline, setDeviceOffline,
        loadingOffline, setLoadingOffline,
        totalLogAction,
        setTotalLogAction,
        dataLicenseStats,
        setDataLicenseStats,
        dataReasonStats,
        setDataReasonStats,
        dataBox,
        setDataBox,
        logActionList,
        setLogActionList,
        loadingLogActionList,
        setLoadingLogActionList,
        loadingLicenseList,
        setLoadingLicenseList,
        licenseListAll,
        setLicenseListAll,
        historyOffline,
        setHistoryOffline,
        loadingHistoryOffline,
        setLoadingHistoryOffline,
        enableLockRemote,
        setEnableLockRemote,
        loadingEnableLockRemote,
        setLoadingEnableLockRemote,
        enableSmoke,
        setEnableSmoke,
        loadingEnableSmoke,
        setLoadingEnableSmoke,
        enableContact,
        setEnableContact,
        loadingEnableContact,
        setLoadingEnableContact,
        deviceStatus,
        setDeviceStatus,
        loadingDeiceStatus,
        setLoadingDeviceStatus,
        loadingHistoryLogs,
        setLoadingHistoryLog,
        historyLogs,
        setHistoryLogs,
        timeoutAllState,
        setTimeoutAllState,
        timeoutInstall,
        setTimeoutInstall,
        timeoutLicense,
        setTimeoutLicense,
        timeOutLwt, setTimeoutLwt,
        timeOutEnableContact,
        setTimeoutEnableContact,
        timeOutEnableSmoke,
        setTimeoutEnableSmoke,
        timeOutEnableLockRemote,
        setTimeoutEnableLockRemote,
        timeOutSwitchOutput,
        setTimeoutSwitchOutput,
        timeOutOnClose,
        setTimeoutOnClose,
        dataListTool,
        setDataListTool,
        listToolRedirect,
        setListToolRedirect,
        userPermission,
        setUserPermission,
        nameDeviceDetail,
        setNameDeviceDetail,
        dataBoxCustomer,
        setDataBoxCustomer,
        deviceOff,
        setDeviceOff,
        loadingDeviceOff,
        setLoadingDeviceOff
    }
}